import { render, staticRenderFns } from "./ZapmailManageWorkspace.vue?vue&type=template&id=5541cdb0"
import script from "./ZapmailManageWorkspace.vue?vue&type=script&lang=js"
export * from "./ZapmailManageWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports